import { IBalanceOfTrade } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getPostfixByActualsValueType } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getPostfixByActualsValueType'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

type TYearType = 'CY' | 'PY' | '2Y' | '3Y'

interface IYearsConfigItem {
  year: TYearType
  botField: string
  totalRevenueField?: string
  hpSpendField?: string
}

export const yearsConfig: IYearsConfigItem[] = [
  {
    year: 'CY',
    botField: 'CurrentYearTotal',
    totalRevenueField: 'CurYearTotal',
    hpSpendField: 'CurrentYearTotal',
  },
  {
    year: 'PY',
    botField: 'PrevYearTotal',
    totalRevenueField: 'PrevYearTotal',
    hpSpendField: 'PrevYearTotal',
  },
  {
    year: '2Y',
    botField: 'TwoYearsAgoTotal',
    totalRevenueField: 'Prev2YearTotal',
    hpSpendField: 'TwoYearsAgoTotal',
  },
  {
    year: '3Y',
    botField: 'ThreeYearsAgoTotal',
  },
]

export const createBoTItem = (
  Key: IBalanceOfTrade['Key'],
  Name: string,
  fields: Partial<IBalanceOfTrade>
): IBalanceOfTrade => {
  return {
    Key,
    Name,
    ...fields,
  } as IBalanceOfTrade
}

export const getFieldsByActualsValueTypes = (
  actualValueTypes: ActualsValueTypes[],
  getValue: (params: {
    postfix: string
    botField: string
    totalRevenueField?: string
    hpSpendField?: string
  }) => number
): Partial<IBalanceOfTrade> => {
  return actualValueTypes.reduce<Partial<IBalanceOfTrade>>((acc, valueType) => {
    const postfix = getPostfixByActualsValueType(valueType)

    return yearsConfig.reduce<Partial<IBalanceOfTrade>>((yearAcc, yearConfig) => {
      const field = `${yearConfig.botField}${postfix}` as keyof IBalanceOfTrade

      return {
        ...yearAcc,
        [field]: getValue({
          postfix,
          botField: yearConfig.botField,
          totalRevenueField: yearConfig.totalRevenueField,
          hpSpendField: yearConfig.hpSpendField,
        }),
      }
    }, acc)
  }, {})
}
